// useRelatives.js
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelativesByUserId } from "../../Profile/redux/thunks/relativesThunks";
import mapRelativeToMember from "../../Profile/functions/relatives/mapRelativeToMember";
import { selectEffectiveUserId } from "../../sous-profile/redux/selectors/sousProfileSelectors";

export default function useRelatives({ autofetch = true } = {}) {
  const dispatch = useDispatch();

  const userId = useSelector(selectEffectiveUserId);
  const { data = [], loading = false, error = null } =
    useSelector((s) => s.relatives || {});

  useEffect(() => {
    if (!autofetch) return;
    if (!userId) return;
    dispatch(fetchRelativesByUserId(userId));
  }, [dispatch, userId, autofetch]);

  const members = useMemo(() => {
    if (!Array.isArray(data)) return [];
    // ✅ passe userId pour que mapRelativeToMember sache qui est l'initiateur
    const mapped = data.map((raw) => mapRelativeToMember(raw, userId));
    const seen = new Set();
    return mapped.filter((m) => {
      const key = String(m.id ?? `${m.relationship}-${m.name}`);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [data, userId]);

  return { members, isLoading: loading, error };
}
